module.exports = __webpack_public_path__ + "img/hospitalizacion.43e72ea2.png";